import { Box, Button, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { viewPDF } from "../../utils/viewPDF";

const ViewVendorBids = () => {
  const [bids, setBids] = useState();
  const { rfqId } = useParams();
  const vendorId = JSON.parse(localStorage.getItem("vendor"));
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const getBids = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/bid/get-by-vendor?vendorId=${vendorId}&rfqId=${rfqId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setBids(res.data);
        setIsLoading(false);
      } catch (error) {
        console.error("Error updating vendor status:", error);
      }
    };
    getBids();
  }, []);

  const groupedWorkItems =
    bids &&
    bids[0]?.bidWorkItems.reduce((acc, item) => {
      if (!acc[item.section]) acc[item.section] = [];
      acc[item.section].push(item);
      return acc;
    }, {});

  useEffect(() => {
    const syncRowHeights = () => {
      const leftTableRows = document.querySelectorAll("#leftTable tbody tr");
      const rightTableRows = document.querySelectorAll("#rightTable tbody tr");

      const rowCount = Math.min(leftTableRows.length, rightTableRows.length);

      for (let i = 0; i < rowCount; i++) {
        const leftHeight = leftTableRows[i].getBoundingClientRect().height;
        const rightHeight = rightTableRows[i].getBoundingClientRect().height;
        const maxHeight = Math.max(leftHeight, rightHeight);

        leftTableRows[i].style.height = `${maxHeight}px`;
        rightTableRows[i].style.height = `${maxHeight}px`;
      }
    };

    // Give time for DOM to paint
    const timeout = setTimeout(syncRowHeights, 100);

    // Resync on window resize
    window.addEventListener("resize", syncRowHeights);

    return () => {
      clearTimeout(timeout);
      window.removeEventListener("resize", syncRowHeights);
    };
  }, [groupedWorkItems]);

  return (
    <div>
      <Typography variant="h4">Quotes Information</Typography>
      <Box className="dashboard-container" p={5}>
        <Typography className="form-title">Commercial Terms</Typography>
        {isLoading ? (
          <Box display="flex" justifyContent="center" mt={5}>
            Loading...
          </Box>
        ) : bids && bids.filter((bid) => bid.deliveryTerms).length > 0 ? (
          <Box sx={{ display: "flex", overflow: "hidden" }}>
            {/* Fixed Left Table */}
            <table
              border={1}
              style={{
                borderCollapse: "collapse",
                width: "50%",
                tableLayout: "fixed",
                textAlign: "center",
                marginBottom: "15px",
              }}
            >
              <thead>
                <th>Terms</th>
              </thead>
              <tbody>
                <tr>
                  <td style={{ padding: "10px" }}>
                    Delivery period (Lead Time)
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: "10px" }}>Payment Terms</td>
                </tr>
                <tr>
                  <td style={{ padding: "10px" }}>Freight</td>
                </tr>
                <tr>
                  <td style={{ padding: "10px" }}>Price Basis (Incoterms)</td>
                </tr>
                <tr>
                  <td style={{ padding: "10px" }}>Warranty Period</td>
                </tr>
                <tr>
                  <td style={{ padding: "10px" }}>Delivery Clause</td>
                </tr>
                <tr>
                  <td style={{ padding: "10px" }}>Attachment 1</td>
                </tr>
                <tr>
                  <td style={{ padding: "10px" }}>Attachment 2</td>
                </tr>
                <tr>
                  <td style={{ padding: "10px" }}>Attachment 3</td>
                </tr>
              </tbody>
            </table>

            {/* Scrollable Vendor Table */}
            <Box sx={{ overflowX: "scroll" }}>
              <table
                border={1}
                style={{
                  borderCollapse: "collapse",
                  minWidth: `${bids.length * 220}px`,
                  textAlign: "center",
                  borderLeft: "none",
                }}
              >
                <thead>
                  {bids && bids.map((bid, i) => <th>Quote {i + 1}</th>)}
                </thead>
                <tbody>
                  {/* Delivery Terms Row */}
                  <tr>
                    {bids.map((bid, i) => (
                      <td key={i} style={{ padding: "10px" }}>
                        {bid.deliveryTerms}
                      </td>
                    ))}
                  </tr>

                  {/* Payment Terms Row */}
                  <tr>
                    {bids.map((bid, i) => (
                      <td key={i} style={{ padding: "10px" }}>
                        {bid.paymentTerms}
                      </td>
                    ))}
                  </tr>

                  {/* Freight Row */}
                  <tr>
                    {bids.map((bid, i) => (
                      <td key={i} style={{ padding: "10px" }}>
                        {bid.freight}
                      </td>
                    ))}
                  </tr>

                  {/* Price Basis Row */}
                  <tr>
                    {bids.map((bid, i) => (
                      <td key={i} style={{ padding: "10px" }}>
                        {bid.priceBasis}
                      </td>
                    ))}
                  </tr>

                  {/* Warranty Period Row */}
                  <tr>
                    {bids.map((bid, i) => (
                      <td key={i} style={{ padding: "10px" }}>
                        {bid.warrantyPeriod}
                      </td>
                    ))}
                  </tr>

                  {/* Delivery Clause Row */}
                  <tr>
                    {bids.map((bid, i) => (
                      <td key={i} style={{ padding: "10px" }}>
                        {bid.deliveryClause}
                      </td>
                    ))}
                  </tr>

                  {/* Attachment Row */}
                  <tr>
                    {bids.map((bid, i) => (
                      <td key={i} style={{ padding: "9px 0 9.5px 0" }}>
                        {bid?.attachment1 && bid.attachment1 !== "N/A" ? (
                          <Button
                            sx={{
                              textDecoration: "underline",
                              padding: 0,
                              minWidth: "auto",
                              fontSize: "12px",
                            }}
                            onClick={() => viewPDF(bid.attachment1, storedUser)}
                          >
                            {bid?.attachment1Filename || "View"}
                          </Button>
                        ) : (
                          <Typography fontSize={"14px"}>N/A</Typography>
                        )}
                      </td>
                    ))}
                  </tr>
                  <tr>
                    {bids.map((bid, i) => (
                      <td key={i} style={{ padding: "9px 0 9.5px 0" }}>
                        {bid?.attachment2 && bid.attachment2 !== "N/A" ? (
                          <Button
                            sx={{
                              textDecoration: "underline",
                              padding: 0,
                              minWidth: "auto",
                              fontSize: "12px",
                            }}
                            onClick={() => viewPDF(bid.attachment2, storedUser)}
                          >
                            {bid?.attachment2Filename || "View"}
                          </Button>
                        ) : (
                          <Typography fontSize={"14px"}>N/A</Typography>
                        )}
                      </td>
                    ))}
                  </tr>
                  <tr>
                    {bids.map((bid, i) => (
                      <td key={i} style={{ padding: "9px 0 9.5px 0" }}>
                        {bid?.attachment3 && bid.attachment3 !== "N/A" ? (
                          <Button
                            sx={{
                              textDecoration: "underline",
                              padding: 0,
                              minWidth: "auto",
                              fontSize: "12px",
                            }}
                            onClick={() => viewPDF(bid.attachment3, storedUser)}
                          >
                            {bid?.attachment3Filename || "View"}
                          </Button>
                        ) : (
                          <Typography fontSize={"14px"}>N/A</Typography>
                        )}
                      </td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </Box>
          </Box>
        ) : (
          <Typography variant="h6" textAlign="center" mt={5}>
            No vendor quote for the tender
          </Typography>
        )}
      </Box>
      <Box className="dashboard-container" p={5}>
        <Typography className="form-title">Quotes Details</Typography>
        {isLoading ? (
          <Box display="flex" justifyContent="center" mt={5}>
            Loading...
          </Box>
        ) : bids && bids.filter(Boolean).length > 0 ? (
          <Box sx={{ display: "flex", overflow: "hidden" }}>
            {/* Fixed Left Table */}
            <table
              id="leftTable"
              style={{
                borderCollapse: "collapse",
                width: "500px",
                tableLayout: "fixed",
                textAlign: "center",
                border: "1px solid #ccc",
                marginBottom: "15px",
              }}
            >
              <thead>
                <tr>
                  <th
                    style={{
                      height: "67px",
                    }}
                  >
                    Item Code
                  </th>
                  <th style={{ width: "50%" }}>Description</th>
                  <th>UOM</th>
                  <th>Quantity</th>
                  <th>GST(in %)</th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(groupedWorkItems).map(
                  ([section, items], sectionIndex) => (
                    <React.Fragment key={sectionIndex}>
                      <tr
                        style={{
                          borderTop: "1px solid #ccc",
                          fontWeight: "bold",
                        }}
                      >
                        <td
                          colSpan={4}
                          style={{
                            textAlign: "left",
                            padding: "10px",
                          }}
                        >
                          Item Group: {section}
                        </td>
                      </tr>
                      {items
                        .sort((a, b) => a.itemOrder - b.itemOrder)
                        .map((item, i) => (
                          <tr key={i}>
                            <td
                              style={{
                                borderTop: "1px solid #ccc",
                                borderRight: "1px solid #ccc",
                                padding: "10px"
                              }}
                            >
                              {item.code}
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #ccc",
                                borderRight: "1px solid #ccc",
                              }}
                            >
                              {item.description}
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #ccc",
                                borderRight: "1px solid #ccc",
                              }}
                            >
                              {item.unit}
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #ccc",
                                borderRight: "1px solid #ccc",
                              }}
                            >
                              {item.quantity}
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #ccc",
                                borderRight: "1px solid #ccc",
                              }}
                            >
                              {item.gst}
                            </td>
                          </tr>
                        ))}
                    </React.Fragment>
                  )
                )}
                <tr>
                  <td
                    colSpan={5}
                    style={{
                      borderTop: "1px solid #ccc",
                      padding: "10px",
                      fontWeight: "bold",
                    }}
                  >
                    Grand Total
                  </td>
                </tr>
                <tr>
                  <td
                    colSpan={5}
                    style={{ borderTop: "1px solid #ccc", padding: "10px" }}
                  >
                    Current Status
                  </td>
                </tr>
              </tbody>
            </table>

            {/* Scrollable Vendor Table */}
            <Box sx={{ overflowX: "scroll" }}>
              <table
                id="rightTable"
                style={{
                  borderCollapse: "collapse",
                  minWidth: `${bids && bids?.length * 250}px`,
                  textAlign: "center",
                  border: "1px solid #ccc",
                  borderLeft: "none",
                }}
              >
                <thead>
                  <tr>
                    {bids.map((_, i) => (
                      <React.Fragment key={i}>
                        <th
                          style={{
                            padding: "8px",
                            borderBottom: "1px solid #ccc",
                            borderRight: "1px solid #ccc",
                          }}
                          colSpan={3}
                        >
                          Quote {i + 1}
                        </th>
                      </React.Fragment>
                    ))}
                  </tr>
                  <tr>
                    {bids.map((_, i) => (
                      <React.Fragment key={i}>
                        <th
                          style={{
                            width: "100px",
                            borderTop: "1px solid #ccc",
                            borderRight: "1px solid #ccc",
                            padding: "8px"
                          }}
                        >
                          Currency
                        </th>
                        <th
                          style={{
                            width: "100px",
                            borderTop: "1px solid #ccc",
                            borderRight: "1px solid #ccc",
                          }}
                        >
                          Rate
                        </th>
                        <th
                          style={{
                            width: "100px",
                            borderTop: "1px solid #ccc",
                            borderRight: "1px solid #ccc",
                          }}
                        >
                          Total
                        </th>
                      </React.Fragment>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(groupedWorkItems).map(
                    ([section, items], sectionIndex) => (
                      <React.Fragment key={sectionIndex}>
                        {/* Section Totals */}
                        <tr
                          style={{
                            borderTop: "1px solid #ccc",
                            fontWeight: "bold",
                          }}
                        >
                          {bids.map((bid, i) => {
                            const sectionItems = bid.bidWorkItems.filter((bi) =>
                              items.find((wi) => wi.itemName === bi.itemName)
                            );
                            return (
                              <React.Fragment key={i}>
                                <td
                                  colSpan={3}
                                  style={{
                                    textAlign: "end",
                                    padding: "10px",
                                    borderRight: "1px solid #ccc",
                                  }}
                                ></td>
                              </React.Fragment>
                            );
                          })}
                        </tr>
                        {items.map((item, rowIndex) => (
                          <tr key={rowIndex}>
                            {bids.map((bid, i) => {
                              const matchedItem = bid.bidWorkItems.find(
                                (bi) => bi.code === item.code
                              );
                              return (
                                <React.Fragment key={i}>
                                  <td
                                    style={{
                                      borderTop: "1px solid #ccc",
                                      borderRight: "1px solid #ccc",
                                    }}
                                  >
                                    {matchedItem?.currency.currency.shortform ||
                                      ""}
                                  </td>
                                  <td
                                    style={{
                                      borderTop: "1px solid #ccc",
                                      borderRight: "1px solid #ccc",
                                    }}
                                  >
                                    {matchedItem?.rate || ""}
                                  </td>
                                  <td
                                    style={{
                                      borderTop: "1px solid #ccc",
                                      borderRight: "1px solid #ccc",
                                    }}
                                  >
                                    {matchedItem?.total || ""}
                                  </td>
                                </React.Fragment>
                              );
                            })}
                          </tr>
                        ))}
                      </React.Fragment>
                    )
                  )}

                  {(() => {
                    // Gather unique currencies across all bids
                    const allCurrencies = new Set();
                    bids.forEach((bid) =>
                      bid.bidWorkItems.forEach(
                        (bi) =>
                          bi.currency &&
                          allCurrencies.add(bi.currency.currency.shortform)
                      )
                    );

                    return [...allCurrencies].map((currency, currencyIndex) => (
                      <tr
                        key={currencyIndex}
                        style={{
                          fontWeight: "bold",
                          borderTop: "1px solid #ccc",
                        }}
                      >
                        {bids.map((bid, i) => {
                          const totalInCurrency = bid.bidWorkItems
                            .filter(
                              (bi) =>
                                bi.currency.currency.shortform === currency
                            )
                            .reduce((sum, bi) => sum + (bi.total || 0), 0);

                          return (
                            <React.Fragment key={i}>
                              <td
                                colSpan={3}
                                style={{
                                  textAlign: "end",
                                  padding: "10px",
                                  borderRight: "1px solid #ccc",
                                }}
                              >
                                Total ({currency}): {totalInCurrency}
                              </td>
                            </React.Fragment>
                          );
                        })}
                      </tr>
                    ));
                  })()}

                  {/* Current Status Row - unchanged */}
                  <tr>
                    {bids.map((bid, i) => (
                      <td
                        key={i}
                        colSpan={3}
                        style={{
                          borderTop: "1px solid #ccc",
                        }}
                      >
                        {bid.bidStatus}
                      </td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </Box>
          </Box>
        ) : (
          <Typography variant="h6" textAlign="center" mt={5}>
            No quotes for the tender
          </Typography>
        )}
      </Box>
      <Box className="btn-container">
        <Button
          className="btn-outlined"
          onClick={() => navigate(`/vendor/dashboard/${rfqId}`)}
        >
          Back
        </Button>
      </Box>
    </div>
  );
};

export default ViewVendorBids;